<!-- 项目类型设置 -->
<template>
    <div class="container containerBox" style="overflow:hidden;">
        <el-card class="box-card" style="width:200px;float:left;">
            <div slot="header" class="clearfix">
                <span>项目类型</span>
            </div>
            <div v-for="o in typeArr" :key="o.oid" class="project-list">
                <el-button @click="handleType(o)" :class="[active === o.oid ? 'acitve project-item': 'project-item']" size="small">{{o.typename}}</el-button>
            </div>
            <div class="project-list">
                <el-button class="project-item" v-if="!isAdd"  icon="el-icon-plus" @click="isAdd = true;">添加类型</el-button>
                <template v-else>
                    <el-input class="addproject" v-model="projectName" v-focus @blur="handleBlur" placeholder="请输入类型名称"></el-input>
                    <i style="margin-left:15px;" class="icon-project el-icon-check"></i>
                </template>
            </div>
        </el-card>
        <el-card class="box-card" style="margin-left:220px;">
            <div slot="header" class="clearfix">
                <span>楼宇结构</span>
                <!-- <el-popover
                    placement="left"
                    width="150"
                    title="结构预览"
                    trigger="hover">
                    <el-tree :data="tmpProjectJson" :props="defaultProps" default-expand-all></el-tree>
                    <el-button slot="reference" @click="handleSave"  style="float: right; padding: 3px 0" type="text">点击保存</el-button>
                </el-popover> -->
                <el-button @click="handleSave"  style="float: right; padding: 3px 0" type="text">点击保存</el-button>
            </div>
            <div class="structure-box">
                <!-- 楼宇结构 -->
                <template v-for="(v, i) in tmpProjectArry">
                    <div class="structure-item" :key="i">
                        <span class="structure-icon">
                            <i class="el-icon-edit icon-btn" @click="handleEdit(v, i)"></i>
                            <template v-if="i===tmpProjectArry.length-1">
                                <el-popover
                                    placement="top"
                                    width="160"
                                    v-model="v.visibleDetele">
                                    <p>确认删除{{v.typename}}吗？</p>
                                    <div style="text-align: right; margin: 0">
                                        <el-button size="mini" type="text" @click="v.visibleDetele = false;">取消</el-button>
                                        <el-button type="primary" size="mini" @click="handleDetele(v,i)">确定</el-button>
                                    </div>
                                    <i slot="reference" class="icon-btn el-icon-delete"></i>
                                </el-popover>
                            </template>
                        </span>
                        <div class="structure-body">
                            <span v-if="v.show" :class='[i===tmpProjectArry.length-1?"structure-title structure-title-last":"structure-title"]'>{{v.typename}}</span>
                            <template v-else>
                                <el-input v-model="v.typename" v-focus="{ foc: !v.show }" @blur="handleBuildName(v,i)" size="small" class="addproject" placeholder="请输入名称1"></el-input>
                                <i style="margin-left:15px;" class="icon-project icon-btn el-icon-check"></i>
                            </template>
                        </div>
                        <template v-if="i===tmpProjectArry.length-1">
                            <div class="structure-button" @click="handleAdd(v,i)">添加下级</div>
                        </template>
                    </div>
                    <div class="structure-spacing" :key="i+'key'"  v-if="i<tmpProjectArry.length-1">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </template>
                <!-- <div class="structure-item">
                    <div class="structure-body">
                        <span class="structure-title">房间</span>
                    </div>
                </div> -->
            </div>
        </el-card>
    </div>
</template>

<script>
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
import { mapGetters } from "vuex";
import { translateDataToTree, treeToPath } from '@/utils/array'
export default {
    name: "projecttypesetting",
    inject: ['reload'],
    data () {
        return {
            tmpProject: [],  // 后台原始数据     
            typeArr: [],    // 项目类型
            active: '',     // 选中项目类型
            isAdd: false,   //  添加输入框
            projectName: '',    // 添加项目名称
            buildData: [],  //楼宇结构数组
            flag: true,  //  是否可添加
            tmpProjectArry: [],     //  楼宇数组结构
            defaultProps: {
                children: 'children',
                label: 'typename'
            },

            saveBool: true,    //  是否保存
        };
    },
    computed: {
        // 预览楼宇结构
        tmpProjectJson() {
            let obj
            this.tmpProject.map(v=>{
                if(v.OID === this.active) obj = v
            })
            return obj ? obj.tmpProjectJson : []
        }
    },
    methods: {
        // 项目类型数组
        initData(data) {
            let arr = [];
            data.forEach((v,i) => {
                let {oid,typename,tmpProjectArry} = v;
                arr.push({oid,typename,tmpProjectArry});
            })
            this.typeArr = arr;
            this.initTmpArry(arr[0].oid);
        },
        // 右侧结构数组
        initTmpArry(oid){
            let obj
            // 筛选对应类型
            this.typeArr.map(v=>{
                if(v.oid === oid) {
                    obj = v;
                }
            });
            // 判断是否新增
            if(obj.tmpProjectArry == undefined) {
                let {typename} = obj
                // 第一层默认项目类型名称
                let newObj = Object.assign({},{typename},{id:0,show: true,visibleDetele: false});
                obj.tmpProjectArry = [newObj];
            }
            this.active = oid;
            this.tmpProjectArry = obj.tmpProjectArry
        },
        // 编辑项目
        handleType(o) {
            this.initTmpArry(o.oid);
        },
        // 新增项目名称
        handleBlur() {
            this.isAdd = false;
            if(this.projectName == '') return;
            this.typeArr.push({typename: this.projectName, oid:'-1'})
            this.initTmpArry('-1');
            this.projectName = ''
        },
        // 输入楼宇名称
        handleAdd(v, i) {
            if(!this.flag) return
            if(v.typename == '') {
                this.$message({
                    message: '请输入名称！',
                    type: 'warning'
                });
                return
            }else{
              this.flag = true;  
            }
            this.tmpProjectArry.splice(i+1,0,{
                id:v.id+1,
                parentId:v.id,
                typename: "",
                show: false,
                visibleDetele: false
            })
        },
        // 编辑楼宇结构
        handleEdit(v, i) {
             this.tmpProjectArry[i].show = false;
             this.flag = false;
        },
        // 保存模板
        async handleSave(){
            let isProjectType = this.typeArr.filter(v=>{
                return v.oid == this.active
            })
            // 新数组存储   typename, id, parentId
            let newTmpProjectArry = []
            this.tmpProjectArry.map(v=>{
                let {typename, id, parentId} = v;
                newTmpProjectArry.push({typename, id, parentId})
            })
            // 参数
            let description = translateDataToTree(newTmpProjectArry);
            let typename = isProjectType[0].typename;
            let data
            if(this.active == -1){
                data = await Service.addTemplate({description, typename});
            } else {
                let oid = isProjectType[0].oid
                data = await Service.editTemplate({description, typename, oid});
            }
            if(data){
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    onClose: ()=>{
                        this.reload();
                    }
                });
            }
        },
        // 删除楼宇结构
        async handleDetele(v, i) {
			
            if(i == 0){
                let _type = this.typeArr.filter(v=>{return v.oid === this.active})
                if(_type[0].oid == '-1'){
                    this.reload();
                }else{
                    // 删除项目
                   let data = await Service.deteleTemplate({oid:_type[0].oid});
                   if(data){
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            onClose: ()=>{
                                this.reload();
                            }
                        });
                    }
                }
                return;
            }
            this.tmpProjectArry[i].visibleDetele = false;
            // 删除最后一项
            this.tmpProjectArry.pop();
        },
        // 楼宇名称输入
        handleBuildName(v, i) {
            if(v.typename == "") {
                this.$message({
                    message: '请输入名称！',
                    type: 'warning'
                });
                return
            }
            this.tmpProjectArry[i].show = true;
            this.flag = true;
        },
        // 格式description
        fmtProjectDes(data) {
            let arr = treeToPath(data)[0]; //  扁平化数组
            let newArr = new Array();
            arr.map(v=>{
                let {typename,id,parentId} = v;
                let obj = Object.assign({},{typename ,id, parentId},{show: true,visibleDetele: false})
                newArr.push(obj)
            })
            return newArr      //  最终格式    [{name: "小区",show: true,visibleDetele: false},{name: "楼栋",show: true,visibleDetele: false}]
        },
        // 格式原始数据
        fmtProjectList(data) {
            let arr = [];
            data.forEach((v,i,data) => {
                v.tmpProjectJson = JSON.parse(v.description);
                v.tmpProjectArry = this.fmtProjectDes(JSON.parse(v.description));
                arr.push(v);
            })
            return arr;
        }
    },
    created() {
        // 获取项目类型
        this.$store.dispatch("getTemplateList").then(res => {
            if(res.length>0) {
                let fmtData = this.fmtProjectList(res); //  格式后台返回数据
                this.tmpProject = fmtData;
                //  初始化数据 项目类型数组、楼宇结构数组
                this.initData(fmtData);
            }
        })
    },
    beforeRouteLeave(to, from , next) {
        if(this.saveBool) {
            next()
        }else{
            $Alert(`是否保存已修改的项目模板`).then(res=>{
                if(res){
                    next(false)
                } else {
                    next()
                }
            })
        }
    }
}

</script>
<style lang='less' scoped>
.project-list{
    .project-item{
        margin-bottom: 20px;
        width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
        &.acitve{
            background-color: @primary-color;
            color: #fff;
        }
    }
    .addproject{
        width: 80%;
    }
    .icon-project{
        margin-left: 15px;
        font-size: 16px;
        cursor: pointer;
        &:hover{
            color: @primary-color;
        }
    }
}

.structure-box{
    overflow: hidden;
    .structure-item{
        float: left;
        border: 1px solid #e8e8e8;
        position: relative;
        width: 200px;
        margin-bottom: 20px;
        .structure-icon{
            position: absolute;
            top: 7px;
            right: 7px;
            font-size: 14px;
            z-index: 9;
            &>i{
                margin-right: 5px;
            }
        }
        .structure-body{
            background-color: #fff;
            text-align: center;
			overflow-x: scroll;
            .structure-title{
                font-size: 24px;
                color: #333;
				max-width: 100%;
                // line-height: 84px;
                line-height: 123px;
                display: inline-block;
                &.structure-title-last{
                    line-height: 84px;
                }
            }
            .addproject{
                width: 60%;
                margin: 31px 0 21px;
            }
        }
        .structure-button{
            background-color: #f7f9fa;
            border-top: 1px solid #e8e8e8;
            height: 38px;
            line-height: 38px;
            color: rgba(0,0,0,.45);
            font-size: 14px;
            cursor: pointer;
            text-align: center;
            &:hover{
                color: @primary-color;
            }
        }
    }
    .structure-spacing{
        margin: 0 5px;
        font-size: 40px;
        color: #333;
        float: left;
        line-height: 125px;
        height: 125px;
        margin-bottom: 20px;
    }
}

</style>